import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from 'app/services/baseQuery'

// Main API slice

export const apiSlice = createApi({
  baseQuery,
  // Use `injectEndpoints` to add addition endpoints
  endpoints: () => ({})
})
